import React from 'react';
import { useSelector } from 'react-redux';
import { CAMPAIGN_GENERATE_TYPE_MANUAL } from '../../../constants';
import CreateManualCampaign from './manualCampaign';
import CreateAlgorithmCampaign from './algorithmCampaign';

function CreateCampaign(props) {
    const { campaignId, handleClose } = props;
    const { campaignGenerationType } = useSelector((state) => state.campaign);

    return (
        CAMPAIGN_GENERATE_TYPE_MANUAL === campaignGenerationType ? <CreateManualCampaign handleClose={handleClose} campaignId={campaignId}/> : <CreateAlgorithmCampaign  handleClose={handleClose} campaignId={campaignId}/>
    );
}

CreateCampaign.defaultProps = {
    campaignId: null,
};

export default CreateCampaign;
